import { ReactNode, useMemo } from 'react';

import isEqual from 'lodash/isEqual';

import { ALL_OPTIONS_VALUE } from './utilityTypes';

type Option<T> = {
  id: string | number;
  label?: ReactNode;
  value: T;
};
export const useAppendAllOption = <T>(
  options: Option<T>[],
  withAllOption = false
) => {
  return useMemo(() => {
    if (withAllOption) {
      options.unshift({
        id: ALL_OPTIONS_VALUE,
        label: 'All',
        value: ALL_OPTIONS_VALUE as T,
      });
    }
  }, [options, withAllOption]);
};

export const withSanitiseFilterIdValue = (value?: number) => {
  if (value === ALL_OPTIONS_VALUE) {
    return undefined;
  }
  return value;
};

export const withSanitiseFiltersIdValue = (value?: number[]) => {
  if (isEqual(value, [ALL_OPTIONS_VALUE])) {
    return undefined;
  }
  return value;
};
